// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    popupTitle: {
        id: 'humidity-popup.title',
        defaultMessage: 'Humidity Controller'
    },
    popupQuestion: {
        id: 'humidity-popup.question',
        defaultMessage: 'What have you connected to the Acc terminal?'
    },
    humidifier: {
        id: 'humidity-popup.humidifier',
        defaultMessage: 'Humidifier'
    },
    dehumidifier: {
        id: 'humidity-popup.dehumidifier',
        defaultMessage: 'Dehumidifier'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/humidity-control-modal/intl.js